
export default function process(state = {}, action)
{
    let response, processedResponseLoc, messageType, error, errorText, statusCode;

    switch(action.type)
    {
        case 'CONVERSATION_PROCESS_RESPONSE':

            response = action.payload.response;
            processedResponseLoc = action.payload.processedResponseLocation;
            messageType = action.payload.messageType;
            error = action.payload.error;
            errorText = action.payload.errorText;
            statusCode = action.payload.statusCode;

            return Object.assign({}, state, {
                [processedResponseLoc] : {
                    response,
                    messageType,
                    error,
                    errorText,
                    statusCode,
                },
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/lib-alme-request/src/reducers/index.js